import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import parse from 'html-react-parser';
import he from 'he';

import sectionBorderRadius from './sectionBorderRadius';
import LinkContainingMessage, { urlsFromText } from './LinkContainingMessage';
import withConfig from '../../../context/withConfig';
import { isRichTextString } from './utils';
import ActionButtons from './ActionButtons';

// Define the animation keyframes
const messageAppear = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const MessageWrapper = styled.div`
  max-width: 65vw;
  padding: 16px 18px;
  color: ${props => props.theme.botMessageFontColor};
  background-color: ${props => props.theme.botMessageBubbleColor};
  flex-grow: 0;
  word-break: break-word;
  word-wrap: break-word;
  cursor: ${props => (props.cursor ? props.cursor : 'auto')};
  text-decoration: ${props =>
    props.type === 'pdf' || props.textDecoration === 'underline' ? 'underline' : 'none'};
  ${sectionBorderRadius};

  animation-name: ${messageAppear};
  animation-duration: 300ms;
  animation-timing-function: linear;
  animation-fill-mode: backwards;
`;

const MessageContent = styled.div`
  margin-bottom: ${props => (props.hasActions ? '12px' : '0')};
`;

export const addLineBreaks = text => {
  const output = [];
  const splitText = text.split('\n');

  splitText.forEach((line, i) => {
    // new line in the 1st line should be hidden
    if (i === 0 && (line === null || line.trim() === '')) {
      return;
    }
    output.push(<span key={i}>{line}</span>);
    output.push(<br key={`lineBreak${i}`} />);
  });
  output.pop();

  return output;
};

class Message extends Component {
  handleOnClick = () => {
    const { src } = this.props;
    if (src) {
      window.open(src, '_blank', 'noopener,noreferrer');
    }
  };

  render() {
    const { text, isStart, isEnd, type, activity } = this.props;
    const urls = type === 'message' && urlsFromText(text);
    if (urls && urls.length > 0 && !isRichTextString(text)) {
      return <LinkContainingMessage text={text} isStart={isStart} isEnd={isEnd} urls={urls} />;
    }

    let processedText = text;
    if (isRichTextString(text)) {
      // Decode HTML entities if present
      processedText = /&#x3C;div&#x3E;/.test(text) ? he.decode(text) : text;
      processedText = parse(processedText);
    } else {
      processedText = addLineBreaks(text);
    }

    const hasActions = activity.suggestedActions && activity.suggestedActions.actions.length > 0;

    return (
      <MessageWrapper
        isStart={isStart}
        isEnd={isEnd}
        data-test-type="botMessage"
        cursor={type === 'pdf' ? 'pointer' : ''}
        onClick={this.handleOnClick}
        type={type}
      >
        <MessageContent hasActions={hasActions}>{processedText}</MessageContent>
        {hasActions && <ActionButtons activity={activity} />}
      </MessageWrapper>
    );
  }
}

export default withConfig(Message);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Message.js